import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ThemePalette } from '@angular/material/core';
import { MatFormFieldModule, SubscriptSizing } from '@angular/material/form-field';
import { NgForOf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

const userTypeOptions = [null, 'internal', 'external'] as const;

export type UserType = (typeof userTypeOptions)[number];

@Component({
  selector: 'app-user-is-external-dropdown',
  template: `
    <mat-form-field [color]="color" class="sm-full-width" [appearance]="appearance" [subscriptSizing]="subscriptSizing">
      <mat-label>{{ 'admin.user-management.account' | translate }}</mat-label>
      <mat-select (selectionChange)="onChange($event)" [value]="value">
        <mat-option *ngFor="let selection of userTypeOptions" [value]="selection">
          {{ getTranslationForSelection(selection || 'all') }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
  styles: [
    `
      :host {
        display: block;
        margin-right: 0;
      }
    `,
  ],
  standalone: true,
  imports: [NgForOf, TranslateModule, MatFormFieldModule, MatSelectModule, MatInputModule],
})
export class UserIsExternalDropdownComponent implements OnInit {
  @Output() selectionChange = new EventEmitter<UserType>();
  @Input() value: UserType;
  @Input() appearance: 'fill' | 'outline';
  @Input() subscriptSizing: SubscriptSizing = 'fixed';
  @Input() color: ThemePalette;

  userTypeOptions = userTypeOptions;

  constructor(private translationService: TranslateService) {}

  ngOnInit(): void {}

  getTranslationForSelection(selection: string) {
    if (!selection || selection === 'all') {
      return this.translationService.instant(`admin.user-management.all`);
    }
    return this.translationService.instant(`admin.user-management.${selection}`);
  }

  onChange(e: any) {
    if (!e) {
      this.selectionChange.emit(null);
    }
    this.selectionChange.emit(e.value);
  }
}
